<template>
  <div class="content-wrapper">
    <loading v-model:active="isLoading" :is-full-page="true" />
    <div v-if="referenceNo == '' || referenceNo == null">
      <div v-if="questions.length > 0">
        <SurveySummary :assessmentDate="assessmentDate" :question-list="questions" 
          v-on:update:score="score = $event" @update:crossSystemScore="crossSystemScore = $event"/>
      </div>

      <div class="content-wrapper">
        <div class="refer-section">
          <div class="refer-card">
            <div class="refer-question">
              <label>Do you want to refer this case?</label>
              <div class="toggle-button" @click="showReferrers = !showReferrers" :class="{ active: showReferrers }">
                <div class="toggle-slider"></div>
                <span class="toggle-text">{{ showReferrers ? 'YES' : 'NO' }}</span>
              </div>
            </div>
          </div>

          <!-- Your Details Section -->
          <div class="patient-details-section" v-if="showReferrers">
            <div class="header-section">
              <div class="title">
                <span>Referral Form</span>
              </div>
            </div>

            <div class="header-section">
              <div class="title">
                <span>Your Details</span>
                <svg class="details-icon" width="24" height="24" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
            </div>

            <div class="form-section">
              <div class="form-group">
                <label for="yourName">Full Name:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                  <input id="yourName" type="text" v-model="yourName" required class="form-input"
                    placeholder="Enter your full name">
                </div>
              </div>

              <div class="form-group">
                <label for="yourAddress">Address:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                  <input id="yourAddress" v-model="yourAddress" required class="form-input"
                    placeholder="Enter your address" />
                </div>
              </div>

              <div class="form-group">
                <label for="yourPostcode">Postcode:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                  <input id="yourPostcode" type="text" v-model="yourPostcode" required class="form-input"
                    placeholder="Enter your postcode">
                </div>
              </div>

              <div class="form-group">
                <label for="yourEmail">Email:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                  <input id="yourEmail" type="email" v-model="yourEmail" required class="form-input"
                    placeholder="Enter your email">
                </div>
              </div>

              <div class="form-group">
                <label for="yourContact">Contact Number:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                  <input id="yourContact" type="tel" v-model="yourContact" required class="form-input"
                    placeholder="Enter your contact number">
                </div>
              </div>
            </div>
          </div>

           <!-- Patient Details Section -->
          <div class="patient-details-section" v-if="showReferrers">
            <div class="header-section">
              <div class="title">
                <span>Patient Details</span>
                <svg class="details-icon" width="24" height="24" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
            </div>

            <div class="form-section">
              <div class="form-group">
                <label for="patientName">Full Name:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                  <input id="patientName" type="text" v-model="patientName" required class="form-input"
                    placeholder="Enter patient's full name">
                </div>
              </div>

              <div class="form-group">
                <label for="patientAddress">Address:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                  <input id="patientAddress" v-model="patientAddress" required class="form-input"
                    placeholder="Enter patient's address" />
                </div>
              </div>

              <div class="form-group">
                <label for="patientPostcode">Postcode:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                  <input id="patientPostcode" type="text" v-model="patientPostcode" required class="form-input"
                    placeholder="Enter patient's postcode">
                </div>
              </div>

              <div class="form-group">
                <label for="patientEmail">Email:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                  <input id="patientEmail" type="email" v-model="patientEmail" required class="form-input"
                    placeholder="Enter patient's email">
                </div>
              </div>

              <div class="form-group">
                <label for="patientContact">Contact Number:</label>
                <div class="input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                  <input id="patientContact" type="tel" v-model="patientContact" required class="form-input"
                    placeholder="Enter patient's contact number">
                </div>
              </div>
            </div>
          </div>

            <!-- Treatment Details Section -->
          <div class="patient-details-section" v-if="showReferrers">
            <div class="header-section">
              <div class="title">
                <span>Treatment Details</span>
                <svg class="details-icon" width="24" height="24" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
                </svg>
              </div>
            </div>

            <div class="form-section">
              <div class="form-group">
                <label>Reason for Referral:</label>
                <div class="checkbox-group">
                  <div class="checkbox-item" v-for="(reason, index) in reasonOptions" :key="index">
                    <label :for="`reason-${index}`" class="checkbox-label">
                      <input type="checkbox" :id="`reason-${index}`" v-model="selectedReasons" :value="reason" />
                      <span>{{ reason }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="toothNumber">Teeth Number(s):</label>
                <button type="button" class="selector-button" @click="showToothSelector = true">
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                  </svg>
                  Select Teeth
                </button>
                <div class="input-wrapper tooth-input-wrapper">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#6B7280"
                      d="M12 2C7.31 2 3.5 5.81 3.5 10.5c0 2.07.77 3.98 2.04 5.43.34.37.77 1.07.77 1.57v2c0 1.1.9 2 2 2h7.38c1.1 0 2-.9 2-2v-2c0-.5.43-1.2.77-1.57 1.27-1.45 2.04-3.36 2.04-5.43 0-4.69-3.81-8.5-8.5-8.5zm2.7 12.3c-.53.4-1.2 1.22-1.2 2.2v2H10.5v-2c0-.98-.67-1.8-1.2-2.2-1.01-1.15-1.8-2.71-1.8-4.3 0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.59-.79 3.15-1.8 4.3z" />
                  </svg>
                  <input id="toothNumber" type="text" v-model="toothNumber" maxlength="4" class="form-input"
                    placeholder="Teeth number(s)">
                </div>
              </div>

              <div class="form-group">
                <label for="furtherInformation">Further Information:</label>
                <textarea id="furtherInformation" v-model="furtherInformation" class="form-textarea"
                  placeholder="Add any additional details about the treatment" rows="3"></textarea>
              </div>
            </div>

            <!-- Tooth Selector Modal -->
            <div class="modal-overlay" v-if="showToothSelector" @click.self="showToothSelector = false">
              <div class="modal-content">
                <ToothSelector 
                  :value="toothNumber"
                  @input="toothNumber = $event" 
                  @close="showToothSelector = false" 
                />
              </div>
            </div>
          </div>

          <div v-if="showReferrers" class="referrers-container">
            <ReferrersList ref="referrersList" @referrer-selected="handleReferrerSelected" :patient-postcode="patientPostcode" />
          </div>

          <!-- Custom Referrer Section -->
          <div v-if="showReferrers" class="custom-referrer-section">
            <div class="refer-card">
              <div class="refer-question">
                <label>Can't see a nearby clinician? 
                  <button type="button" class="link-button" @click="toggleCustomReferrer">
                    Click here to refer to someone you know.
                  </button>
                </label>
              </div>
            </div>

            <!-- Custom Referrer Details -->
            <div class="patient-details-section" v-if="showCustomReferrer">
              <div class="header-section">
                <div class="title">
                  <span>Custom Referrer Clinician</span>
                  <svg class="details-icon" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                  </svg>
                </div>
              </div>

              <div class="form-section">
                <div class="form-group">
                  <label for="customReferrerName">Referrer Full Name:</label>
                  <div class="input-wrapper">
                    <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#6B7280"
                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                    <input id="customReferrerName" type="text" v-model="customReferrerName" required class="form-input"
                      placeholder="Enter referrer's full name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="customReferrerEmail">Referrer Email:</label>
                  <div class="input-wrapper">
                    <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#6B7280"
                        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                    <input id="customReferrerEmail" type="email" v-model="customReferrerEmail" required class="form-input"
                      placeholder="Enter referrer's email address">
                  </div>
                </div>

                <div class="form-group">
                  <label for="customReferrerAddress">Referrer Address Line 1:</label>
                  <div class="input-wrapper">
                    <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#6B7280"
                        d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    <input id="customReferrerAddress" type="text" v-model="customReferrerAddress" class="form-input"
                      placeholder="Enter address line 1">
                  </div>
                </div>
                <div class="form-group">
                  <label for="customReferrerCity">Referrer Town/City:</label>
                  <div class="input-wrapper">
                    <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#6B7280"
                        d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    <input id="customReferrerCity" type="text" v-model="customReferrerCity" class="form-input"
                      placeholder="Enter town/city">
                  </div>
                </div>
                <div class="form-group">
                  <label for="customReferrerPostcode">Referrer Postcode:</label>
                  <div class="input-wrapper">
                    <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#6B7280"
                        d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    <input id="customReferrerPostcode" type="text" v-model="customReferrerPostcode" class="form-input"
                      placeholder="Enter postcode">
                  </div>
                </div>

                <div class="form-group">
                  <label for="customReferrerPractice">Practice Name (Optional):</label>
                  <div class="input-wrapper">
                    <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="#6B7280"
                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                    <input id="customReferrerPractice" type="text" v-model="customReferrerPractice" class="form-input"
                      placeholder="Enter practice name (optional)">
                  </div>
                </div>

                <div class="form-group">
                  <button type="button" class="btn-secondary small-btn" @click="clearCustomReferrer">
                    <svg class="btn-icon" width="16" height="16" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                    Cancel Custom Referrer Clinician
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="refer-card" v-if="showReferrers">
            <div class="refer-question">
              <label>Do you want to send the patient an information leaflet?</label>
              <div class="toggle-button" @click="sendInformationLeafet = !sendInformationLeafet"
                :class="{ active: sendInformationLeafet }">
                <div class="toggle-slider"></div>
                <span class="toggle-text">{{ sendInformationLeafet ? 'YES' : 'NO' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn-secondary" v-on:click="back()">
          <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
          Back
        </button>
        <button class="btn-primary" v-on:click="complete()">
          <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
          </svg>
          {{ showReferrers ? 'Complete Referral' : 'Save Assessment' }}
        </button>
      </div>
    </div>

    <div v-if="referenceNo != ''" class="success-container">
      <div class="success-icon-container">
        <svg class="success-icon" width="64" height="64" viewBox="0 0 24 24">
          <path fill="#10B981"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      </div>
      <h2 class="success-title">Assessment Completed</h2>

      <div v-if="showReferrers && (selectedReferrerId || showCustomReferrer)" class="referral-success-info">
      <div class="info-card">
        <svg class="info-icon" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#013B82"
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
        </svg>
        <div class="info-content">
          <p>Your referral has been successfully emailed to <strong>{{ effectiveReferrerName }}</strong>.</p>
          <p>
              <strong>{{ patientName }}</strong> has also been provided with details of the referral practice, as well as an information leaflet if you had opted to provide this.
          </p>
          <p>You may also review and download a summary of this referral in the 'My Assessments' page.</p>
          <p>Thank you for using the Endo360 referral system. </p>
        </div>
      </div>
    </div>

      <div class="reference-container">
        <p class="reference-label">Reference ID:</p>
        <p class="reference-number">{{ referenceNo }}</p>
        <button class="copy-button" @click="copyReferenceToClipboard">
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
          </svg>
          Copy
        </button>
      </div>
      <p class="success-description">You may wish to note the above reference ID for your records.</p>
      <p class="success-description">This reference ID may be used in referrals or in patient records to review the
        details of this case assessment.</p>
      <p class="success-description">Registered users may also review previous assessments using the <router-link
          to="/admin/user-report" class="report-link">Reports page</router-link>.</p>
      <p class="success-description">Thank you for using {{ title }}.</p>
      <button class="btn-primary start-again-btn" v-on:click="startAgain()">
        <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
        </svg>
        Start Again
      </button>
    </div>

  </div>
</template>
<script>

import SurveySummary from '../../components/SurveySummary.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import authStore from "../../store/auth-store";
import { useToast } from "vue-toastification";
import moment from 'moment'

import ReferrersList from './components/referrers/ReferrersList'
import ToothSelector from './components/ToothSelector.vue';

export default {

  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      assessmentDate: moment().format('DD MMM yyyy'),
      isLoading: false,
      isRCatSystem: false,
      questions: [],
      score: 0,
      crossSystemScore: 0,
      reportUrl: window.location.origin + process.env.BASE_URL + "#/admin/user-report",

      referenceNo: "",
      showReferrers: false,
      sendInformationLeafet: false,
      showToothSelector: false,

      selectedReferrerId: null,
      selectedReferrerName: null,
      selectedReferrerEmail: null,

      // Custom referrer fields
      showCustomReferrer: false,
      customReferrerName: '',
      customReferrerEmail: '',
      customReferrerAddress: '',
      customReferrerCity: '',
      customReferrerPostcode: '',
      customReferrerPractice: '',

      // Treatment details
      reasonOptions: [
        "Consultation Only",
        "Restorability Assessment/Investigation",
        "Endodontic Treatment",
        "Endodontic Surgery",
        "Definitive Restoration",
        "Vital Pulp Therapy"
      ],
      selectedReasons: [],
      toothNumber: "",
      furtherInformation: "",

      // Your details
      yourName: '',
      yourAddress: '',
      yourPostcode: '',
      yourContact: '',
      yourEmail: '',

      // Patient details
      patientName: '',
      patientAddress: '',
      patientPostcode: '',
      patientEmail: '',
      patientContact: ''
    }
  },

  mounted() {
    this.isRCatSystem = localStorage.getItem('@app-system') === 'rcat';
    this.questions = this.getQuestions();
    this.getUserDetails();
  },

  methods: {
    async getUserDetails() {
      if (this.user) {
        try {
          this.isLoading = true;
          const response = await this.axios.get("/api/auth/getuserdetails", { headers: { 'Authorization': 'Bearer ' + this.user.token } });
          if (response.status === 200) {
            const userDetails = response.data;
            // Prefill the user details
            this.yourName = userDetails.name || '';
            this.yourPostcode = userDetails.postcode || '';
            this.yourEmail = userDetails.email;
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
          this.toast.error("Failed to load your details");
        } finally {
          this.isLoading = false;
        }
      }
    },

    copyReferenceToClipboard() {
      navigator.clipboard.writeText(this.referenceNo)
        .then(() => {
          this.toast.success("Reference ID copied to clipboard");
        })
        .catch(err => {
          this.toast.error("Failed to copy reference ID");
          console.error('Could not copy text: ', err);
        });
    },

    handleReferrerSelected(id, name, email = null) {
      this.selectedReferrerId = id;
      this.selectedReferrerName = name;
      this.selectedReferrerEmail = email;
      
      // Clear custom referrer when selecting from list
      if (this.showCustomReferrer) {
        this.clearCustomReferrer();
      }
    },

    toggleCustomReferrer() {
      this.showCustomReferrer = !this.showCustomReferrer;
      
      // Clear selected referrer when switching to custom
      if (this.showCustomReferrer) {
        this.selectedReferrerId = null;
        this.selectedReferrerName = null;
        this.selectedReferrerEmail = null;

        this.$refs.referrersList?.clearSelection();
      }
    },

    clearCustomReferrer() {
      this.showCustomReferrer = false;
      this.customReferrerName = '';
      this.customReferrerEmail = '';
      this.customReferrerAddress = '';
      this.customReferrerCity = '';
      this.customReferrerPostcode = '';
      this.customReferrerPractice = '';
    },

    back() {
      if (confirm("Are you sure you want to go back? This will allow you to edit the current assessment.\n\nIf you would like to start a new case assessment, please select 'Save Assessment'.")) {
        this.$router.push("/survey");
      }
    },
    
    startAgain() {
      if (confirm("Are you sure you want to start again?")) {
        this.$router.push("/");
      }
    },
    
    getQuestions() {
      var storedQuestionsJson = localStorage.getItem("@survey-questions");
      if (storedQuestionsJson == null) {
        this.$router.push("/");
        return;
      }

      // Parse and sort questions by position
      const questions = JSON.parse(storedQuestionsJson);
      return questions.sort((a, b) => a.position - b.position);
    },

    validateDetails() {
      const errors = [];

      // Validate Treatment Details
      if (this.showReferrers) {
        if (this.selectedReasons.length === 0) {
          errors.push('Please select at least one reason for referral');
        }

        if (!this.toothNumber.trim()) {
          errors.push('Tooth number is required');
        }
      }

      // Validate Your Details
      if (this.showReferrers) {
        if (!this.yourName.trim()) {
          errors.push('Your full name is required');
        }

        if (!this.yourEmail.trim()) {
          errors.push('Your email is required');
        } else if (!this.isValidEmail(this.yourEmail)) {
          errors.push('Please enter a valid email address for yourself');
        }

        if (!this.yourContact.trim()) {
          errors.push('Your contact number is required');
        } else if (!this.isValidPhone(this.yourContact)) {
          errors.push('Please enter a valid contact number for yourself');
        }

        if (!this.yourPostcode.trim()) {
          errors.push('Your postcode is required');
        }
      }

      // Validate Patient Details
      if (this.showReferrers) {
        if (!this.patientName.trim()) {
          errors.push('Patient full name is required');
        } else if (this.patientName.trim().length < 2) {
          errors.push('Patient full name must be at least 2 characters long');
        }

        if (!this.patientEmail.trim()) {
          errors.push('Patient email is required');
        } else if (!this.isValidEmail(this.patientEmail)) {
          errors.push('Please enter a valid email address for the patient');
        }

        if (!this.patientContact.trim()) {
          errors.push('Patient contact number is required');
        } else if (!this.isValidPhone(this.patientContact)) {
          errors.push('Please enter a valid contact number for the patient');
        }

        if (!this.patientPostcode.trim()) {
          errors.push('Patient postcode is required');
        }
      }

      // Validate Custom Referrer Details
      if (this.showReferrers && this.showCustomReferrer) {
        if (!this.customReferrerName.trim()) {
          errors.push('Custom referrer name is required');
        }

        if (!this.customReferrerEmail.trim()) {
          errors.push('Custom referrer email is required');
        } else if (!this.isValidEmail(this.customReferrerEmail)) {
          errors.push('Please enter a valid email address for the custom referrer');
        }

        if (!this.customReferrerAddress.trim()) {
          errors.push('Custom referrer address is required');
        }

         if (!this.customReferrerCity.trim()) {
          errors.push('Custom referrer town/city is required');
        }

         if (!this.customReferrerPostcode.trim()) {
          errors.push('Custom referrer address is required');
        }
      }

      // Validate that either a referrer is selected OR custom referrer is provided
      if (this.showReferrers && !this.selectedReferrerId && !this.showCustomReferrer) {
        errors.push('Please select a referrer from the list or add a custom referrer');
      }

      return {
        isValid: errors.length === 0,
        errors
      };
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    isValidPhone(phone) {
      const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,9}$/;
      return phoneRegex.test(phone);
    },

    async complete() {
      if (this.showReferrers) {
        const { isValid, errors } = this.validateDetails();

        if (!isValid) {
          errors.forEach(error => this.toast.error(error));
          return;
        }
      }

      this.questions = this.getQuestions();

      // Questions are already sorted by getQuestions(), no need to sort again
      var questions = this.questions.map(q => ({
        question: q.title,
        imageBase64: q.imageBase64,
        systemType: q.systemType,
        responses: q.responses.filter(r => r.isSelected == true).map(r => ({
          response: r.response,
          weight: r.weight,
          measurementAngle: r.measurementAngle
        }))
      }));

      // Determine referrer details
      let referrerId = this.selectedReferrerId;
      let referrerEmail = this.selectedReferrerEmail;
      let referrerName = this.selectedReferrerName;

      // If using custom referrer
      if (this.showCustomReferrer && this.customReferrerName && this.customReferrerEmail) {
        referrerId = null; // No ID for custom referrer
        referrerEmail = this.customReferrerEmail;
        referrerName = this.customReferrerName;
      } else if (referrerId == null && this.showReferrers == true) {
        // Refer to self (existing logic)
        referrerId = authStore.state.user.id;
      }

      var dto = {
        applicationUserId: this.user ? this.user.id : null,
        score: this.score,
        otherSystemScore: this.crossSystemScore,
        questions: questions,
        isSimulated: localStorage.getItem("@is-simulated") == "true",
        referrerId: referrerId,

        // Treatment details
        referralReasons: this.selectedReasons.join(", "),
        toothNumber: this.toothNumber,
        furtherInformation: this.furtherInformation,

        // Your details
        yourName: this.yourName,
        yourAddress: this.yourAddress,
        yourPostcode: this.yourPostcode,
        yourContact: this.yourContact,
        yourEmail: this.yourEmail,

        // Patient details
        patientName: this.patientName,
        patientAddress: this.patientAddress,
        patientPostcode: this.patientPostcode,
        patientEmail: this.patientEmail,
        patientContact: this.patientContact,

        // Custom referrer details
        customReferrerName: this.showCustomReferrer ? this.customReferrerName : null,
        customReferrerEmail: this.showCustomReferrer ? this.customReferrerEmail : null,
        customReferrerPractice: this.showCustomReferrer ? this.customReferrerPractice : null,
        customReferrerAddress: this.showCustomReferrer ? this.customReferrerAddress : null,
        customReferrerCity: this.showCustomReferrer ? this.customReferrerCity : null,
        customReferrerPostcode: this.showCustomReferrer ? this.customReferrerPostcode : null,

        sendInformationLeafet: this.sendInformationLeafet
      }

      this.isLoading = true;
      var response = await this.axios.post("/api/survey/post", dto);
      this.isLoading = false;

      if (response.status != 200) {
        this.toast.error("Error saving survey. Please try again");
        return;
      }

      this.toast.success("Successfully saved survey");
      this.referenceNo = response.data;
      localStorage.setItem("@survey-questions", "[]");
      localStorage.setItem("@screening-questions", "[]");
      localStorage.removeItem("@is-simulated");
    }
  },

  computed: {
    isLoggedIn() {
      return authStore.state.user != null;
    },
    user() {
      return authStore.state.user;
    },
    title() {
      if (this.isRCatSystem)
        return "R-CAT";
      
      return "E-CAT";
    },
    effectiveReferrerName() {
      if (this.showCustomReferrer && this.customReferrerName) {
        return this.customReferrerName;
      }
      return this.selectedReferrerName;
    }
  },

  components: {
    Loading,
    SurveySummary,
    ReferrersList,
    ToothSelector
  },
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  margin: 0 auto;
  padding: 20px 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.refer-section {
  margin: 0 auto 30px;
}

.refer-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid #E5E7EB;
}

.refer-question {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 12px;

  label {
    display: block;
    font-weight: 600;
    color: #111827;
    font-size: 16px;
  }
}

.toggle-button {
  position: relative;
  width: 80px;
  height: 34px;
  background-color: #E5E7EB;
  border-radius: 17px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &.active {
    background-color: #013B82;

    .toggle-slider {
      transform: translateX(46px);
    }

    .toggle-text {
      color: white;
    }
  }

  .toggle-slider {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 26px;
    height: 26px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .toggle-text {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 12px;
    line-height: 34px;
    font-weight: bold;
    color: #6B7280;
    user-select: none;
  }
}

.referrers-container {
  margin-bottom: 24px;
}

// NEW CUSTOM REFERRER STYLES
.custom-referrer-section {
  margin-bottom: 24px;
}

.link-button {
  background: none;
  border: none;
  color: #013B82;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  margin-left: 4px;
  
  &:hover {
    color: #0A2D5C;
    text-decoration: none;
  }
}

.small-btn {
  padding: 8px 16px;
  font-size: 14px;
  
  .btn-icon {
    width: 16px;
    height: 16px;
  }
}

.patient-details-section {
  margin: 24px 0;

  .header-section {
    margin-bottom: 15px;

    .title {
      padding: 14px 18px;
      background: linear-gradient(135deg, #013B82, #0A2D5C);
      color: #FFF;
      font-weight: 600;
      border-radius: 10px;
      box-shadow: 0 2px 6px rgba(1, 59, 130, 0.15);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .details-icon {
        color: white;
      }
    }
  }
}

.form-section {
  padding: 24px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .form-group {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      text-align: left;
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
      color: #374151;
    }
  }
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 6px 0;

  .checkbox-item {
    display: flex;
    align-items: center;

    .checkbox-label {
      display: flex;
      align-items: center;
      cursor: pointer;

      input[type="checkbox"] {
        margin-right: 10px;
        width: 18px;
        height: 18px;
        accent-color: #013B82;
        cursor: pointer;
      }

      span {
        font-size: 15px;
        color: #4B5563;
      }
    }
  }
}

.input-wrapper {
  position: relative;

  .input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &.tooth-input-wrapper {
    max-width: 200px;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
}

.form-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: white;

  &:focus {
    border-color: #013B82;
    box-shadow: 0 0 0 3px rgba(1, 59, 130, 0.1);
    outline: none;
  }

  &::placeholder {
    color: #9CA3AF;
  }
}

.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: white;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;

  &:focus {
    border-color: #013B82;
    box-shadow: 0 0 0 3px rgba(1, 59, 130, 0.1);
    outline: none;
  }

  &::placeholder {
    color: #9CA3AF;
  }
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 30px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
}

.btn-primary,
.btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: none;

  .btn-icon {
    flex-shrink: 0;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #013B82, #0A2D5C);
  color: white;
  box-shadow: 0 2px 6px rgba(1, 59, 130, 0.2);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(1, 59, 130, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(1, 59, 130, 0.2);
  }
}

.btn-secondary {
  background: white;
  color: #4B5563;
  border: 1px solid #D1D5DB;

  &:hover {
    background: #F9FAFB;
    color: #111827;
    border-color: #9CA3AF;
  }

  &:active {
    background: #F3F4F6;
  }
}

.success-container {
  background: white;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #E5E7EB;
  max-width: 600px;
  margin: 40px auto;
}

.success-icon-container {
  margin-bottom: 20px;
}

.success-title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 24px;
}

.reference-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
  background: #F3F4F6;
  padding: 16px;
  border-radius: 8px;
}

.reference-label {
  font-weight: 600;
  color: #4B5563;
}

.reference-number {
  font-weight: 700;
  font-size: 18px;
  color: #111827;
  text-decoration: underline;
  margin: 0;
}

.copy-button {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  background: white;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  font-size: 14px;
  color: #4B5563;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #F9FAFB;
    border-color: #9CA3AF;
  }
}

.success-description {
  line-height: 1.6;
  color: #4B5563;
  margin-bottom: 16px;
  font-size: 15px;
}

.report-link {
  color: #013B82;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.start-again-btn {
  margin-top: 24px;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 0px;
  }

  .form-section {
    padding: 0px;
  }

  .form-input {
    padding: 10px 14px 10px 36px;
    font-size: 14px;
  }

  .reference-container {
    flex-direction: column;
    padding: 12px;
  }

  .action-buttons {
    gap: 10px;
  }

  .btn-primary,
  .btn-secondary {
    padding: 12px 16px;
    font-size: 15px;
  }

  .success-container {
    padding: 20px;
  }
}

.input-wrapper.tooth-input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  
  .form-input {
    flex: 1;
  }
}

.selector-button {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #013B82;
  background-color: #EFF6FF;
  border: 1px solid #BFDBFE;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #DBEAFE;
    border-color: #93C5FD;
  }
  
  svg {
    flex-shrink: 0;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.referral-success-info {
  margin: 0 0 24px 0;
}

.info-card {
  background-color: #f0f7ff;
  border-left: 4px solid #013B82;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  text-align: left;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-icon {
  flex-shrink: 0;
  margin-top: 3px;
}

.info-content {
  flex: 1;
}

.info-content p {
  margin: 8px 0;
  color: #374151;
  font-size: 15px;
  line-height: 1.5;
}

.info-content p:first-child {
  margin-top: 0;
}

.info-content p:last-child {
  margin-bottom: 0;
}
</style>